"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContractOurDetails;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const Tools_1 = __importDefault(require("../../../React/Tools/Tools"));
const ToolsDate_1 = __importDefault(require("../../../React/Tools/ToolsDate"));
const CommonComponents_1 = require("../../../View/Resultsets/CommonComponents");
const FilterableTable_1 = __importDefault(require("../../../View/Resultsets/FilterableTable/FilterableTable"));
const ContractsController_1 = require("../ContractsController");
const ContractDetailsContext_1 = require("./ContractDetailsContext");
const InvoiceModalButtons_1 = require("../../../Erp/InvoicesList/Modals/InvoiceModalButtons");
const ToolsFetch_1 = __importDefault(require("../../../React/Tools/ToolsFetch"));
function ContractOurDetails() {
    const { contract, setContract, contractsRepository } = (0, ContractDetailsContext_1.useContractDetails)();
    const [settlemenData, setSettlemenData] = (0, react_1.useState)(undefined);
    const [invoices, setInvoices] = (0, react_1.useState)([]);
    const [externalUpdate, setExternalUpdate] = (0, react_1.useState)(0);
    const [summarySheet, setSummarySheet] = (0, react_1.useState)(undefined);
    const [isGeneratingSummary, setIsGeneratingSummary] = (0, react_1.useState)(false);
    const [summaryError, setSummaryError] = (0, react_1.useState)(undefined);
    if (!contract)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Nie wybrano umowy");
    if (!contract._lastUpdated)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Umowa nie ma daty aktualizacji");
    //fetch data
    (0, react_1.useEffect)(() => {
        fetchData();
    }, []);
    async function fetchData() {
        if (!contract?.id)
            throw new Error("Nie wybrano kontraktu");
        const contractIdString = contract.id.toString();
        const fetchSettlementData = (await ContractsController_1.contractsSettlementRepository.loadItemsFromServerPOST([{ id: contractIdString }]))[0];
        // Bez uprawnień do faktur nie ma po co pytać serwera - odpowiedziałby 403.
        const fetchInvoicesData = MainSetupReact_1.default.canViewInvoices()
            ? await ContractsController_1.invoicesRepository.loadItemsFromServerPOST([{ contractId: contractIdString }])
            : [];
        try {
            const [settlementData] = await Promise.all([fetchSettlementData, fetchInvoicesData]);
            setSettlemenData(settlementData);
            setInvoices(fetchInvoicesData);
            setExternalUpdate((prevState) => prevState + 1);
        }
        catch (error) {
            console.error("Error fetching data", error);
            // Handle error as you see fit
        }
    }
    function renderInvoiceTotaValue(invoice) {
        return (react_1.default.createElement(react_1.default.Fragment, null, invoice._totalNetValue && react_1.default.createElement("div", { className: "text-end" }, Tools_1.default.formatNumber(invoice._totalNetValue))));
    }
    function renderCoordinatorData() {
        if (!contract)
            return (react_1.default.createElement(react_bootstrap_1.Placeholder, { as: "div", animation: "glow" },
                react_1.default.createElement(react_bootstrap_1.Placeholder, { xs: 6 })));
        const contractTyped = contract;
        const coordinatorName = contractTyped._manager
            ? `${contractTyped._manager.name} ${contractTyped._manager.surname}`
            : "Nie określono";
        return react_1.default.createElement(react_1.default.Fragment, null, `Koordynator(ka): ${coordinatorName}`);
    }
    /**
     * Arkusz powstaje po stronie serwera na Dysku kontraktu - tu tylko wołamy endpoint
     * i otwieramy wynik. Link zostaje też w alercie, bo przeglądarka potrafi zablokować
     * window.open otwierane po odpowiedzi serwera (poza gestem użytkownika).
     */
    async function generateSummarySheet() {
        if (!contract?.id)
            return;
        setIsGeneratingSummary(true);
        setSummaryError(undefined);
        setSummarySheet(undefined);
        try {
            const result = await ToolsFetch_1.default.fetchJsonWithSafeError(MainSetupReact_1.default.serverUrl + "contractInvoiceSummarySheet", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ contractId: contract.id }),
            }, "Nie udało się wygenerować arkusza podsumowującego");
            setSummarySheet(result);
            if (result?.url)
                window.open(result.url, "_blank");
        }
        catch (error) {
            setSummaryError(error instanceof Error ? error.message : String(error));
        }
        finally {
            setIsGeneratingSummary(false);
        }
    }
    function renderActionsMenu() {
        const contractTyped = contract;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(InvoiceModalButtons_1.InvoiceAddNewModalButton, { modalProps: {
                    onAddNew: async () => {
                        // Faktura jest już zapisana, a modal czeka na ten callback - nieudane
                        // odświeżenie widoku nie może wyglądać jak nieudany zapis i blokować
                        // zamknięcia. Dane wrócą przy następnym wejściu w kontrakt.
                        try {
                            await fetchData();
                        }
                        catch (error) {
                            console.error("Nie udało się odświeżyć danych kontraktu po dodaniu faktury", error);
                        }
                    },
                    contextData: contract,
                }, buttonProps: { buttonCaption: "Dodaj fakturę" } }),
            MainSetupReact_1.default.canViewInvoices() && contractTyped.gdFolderId && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", 
                // size="sm" jak w GeneralAddNewModalButton - inaczej ten przycisk
                // jest wyższy od sąsiada w tym samym rzędzie.
                size: "sm", className: "ms-2", disabled: isGeneratingSummary, onClick: generateSummarySheet }, isGeneratingSummary ? "Generuję..." : "Arkusz podsumowujący"))));
    }
    return (react_1.default.createElement(react_bootstrap_1.Card, null,
        react_1.default.createElement(react_bootstrap_1.Card.Body, null,
            react_1.default.createElement(react_bootstrap_1.Container, null,
                react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, null, contract.comment && react_1.default.createElement("p", null,
                        "Opis: ",
                        contract.comment))),
                react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, null, renderActionsMenu())),
                summaryError && (react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", dismissible: true, onClose: () => setSummaryError(undefined) }, summaryError)))),
                summarySheet?.url && (react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success", dismissible: true, onClose: () => setSummarySheet(undefined) },
                            "Arkusz podsumowuj\u0105cy gotowy.",
                            " ",
                            react_1.default.createElement(react_bootstrap_1.Alert.Link, { href: summarySheet.url, target: "_blank", rel: "noreferrer" }, "Otw\u00F3rz arkusz"))))),
                react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3 text-end" },
                    react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                        react_1.default.createElement("div", null, "Warto\u015B\u0107 netto, z\u0142:"),
                        settlemenData && Tools_1.default.isNumber(settlemenData.value) ? (react_1.default.createElement("h5", null, Tools_1.default.formatNumber(settlemenData.value))) : ("Jeszcze nie określono")),
                    react_1.default.createElement(CommonComponents_1.MyTooltip, { content: "Na podstawie faktur wys\u0142anych", placement: "top" },
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                            react_1.default.createElement("div", null, "Rozliczono, z\u0142:"),
                            settlemenData && Tools_1.default.isNumber(settlemenData?.totalIssuedValue) ? (react_1.default.createElement("h5", null, Tools_1.default.formatNumber(settlemenData.totalIssuedValue))) : ("Jeszcze nie wysłano faktur"))),
                    react_1.default.createElement(CommonComponents_1.MyTooltip, { content: "Na podstawie faktur wys\u0142anych", placement: "top" },
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                            react_1.default.createElement("div", null, "Do rozliczenia, z\u0142:"),
                            settlemenData && Tools_1.default.isNumber(settlemenData.remainingIssuedValue) ? (react_1.default.createElement("h5", null, Tools_1.default.formatNumber(settlemenData.remainingIssuedValue))) : ("Jeszcze nie określono"))),
                    react_1.default.createElement(CommonComponents_1.MyTooltip, { content: "Na podstawie faktur zarejestrowanych", placement: "top" },
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2, className: "text-muted" },
                            react_1.default.createElement("div", null, "Zarejestrowano, z\u0142:"),
                            settlemenData && Tools_1.default.isNumber(settlemenData?.totalRegisteredValue) ? (react_1.default.createElement("h5", null, Tools_1.default.formatNumber(settlemenData.totalRegisteredValue))) : ("Jeszcze nie wysłano faktur"))),
                    react_1.default.createElement(CommonComponents_1.MyTooltip, { content: "Na podstawie faktur zarejestrowanych", placement: "top" },
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2, className: "text-muted" },
                            react_1.default.createElement("div", null, "Do zarejestrowania, z\u0142:"),
                            settlemenData && Tools_1.default.isNumber(settlemenData.remainingRegisteredValue) ? (react_1.default.createElement("h5", null, Tools_1.default.formatNumber(settlemenData.remainingRegisteredValue))) : ("Jeszcze nie określono")))),
                MainSetupReact_1.default.canViewInvoices() && (react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                        react_1.default.createElement("div", null, "Faktury")),
                    react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                        react_1.default.createElement(FilterableTable_1.default, { id: "invoices", title: "", tableStructure: [
                                { header: "Numer", objectAttributeToShow: "number", colMd: 1 },
                                {
                                    header: "Sprzedaż",
                                    renderTdBody: (invoice) => (react_1.default.createElement("div", { className: "text-end" }, invoice.issueDate)),
                                    colMd: 2,
                                },
                                {
                                    header: "Status",
                                    renderTdBody: (invoice) => (react_1.default.createElement(CommonComponents_1.InvoiceStatusBadge, { status: invoice.status })),
                                    colMd: 1,
                                },
                                {
                                    header: "Wysłano",
                                    renderTdBody: (invoice) => (react_1.default.createElement("div", { className: "text-end" }, invoice.sentDate)),
                                    colMd: 2,
                                },
                                { header: "Netto, zł", renderTdBody: renderInvoiceTotaValue, colMd: 2 },
                                {
                                    header: "Termin płatności",
                                    renderTdBody: (invoice) => (react_1.default.createElement("div", { className: "text-end" }, invoice.paymentDeadline)),
                                    colMd: 2,
                                },
                            ], initialObjects: invoices, repository: ContractsController_1.invoicesRepository, selectedObjectRoute: "/invoice/", isDeletable: false, externalUpdate: externalUpdate }))))),
            react_1.default.createElement("p", { className: "tekst-muted small" },
                "Koordynator(ka): ",
                renderCoordinatorData(),
                react_1.default.createElement("br", null),
                "Aktualizacja: ",
                ToolsDate_1.default.dateToDDmmmYYYYHHMM(contract._lastUpdated)))));
}
